'use es6';

import I18n from 'I18n';
import { Provider } from 'react-redux';
import AppContainer from './AppContainer';
import defaultClient from 'hub-http/clients/apiClient';
import FormState from 'MeetingsLib/models/FormState';
import TrackingParams from 'MeetingsLib/models/TrackingParams';
import ABTestingParams from 'MeetingsLib/models/ABTestingParams';
import ErrorBoundary from 'MeetingsLib/components/ErrorBoundary';
import { createStore } from 'MeetingsLib/utils/createStore';
import { PublicAvailabilityInfoProvider } from 'MeetingsLib/context/PublicAvailabilityInfoContext';
import { TroubleshootTimesContextProvider } from 'MeetingsLib/context/TroubleshootTimesContext';
import { DataFetchingClient, DataFetchingClientProvider } from 'data-fetching-client';
import { jsx as _jsx } from "react/jsx-runtime";
export default function createBookingComponent({
  httpClient = defaultClient,
  embedded = true,
  slug,
  formState = {},
  forceOffline,
  timezone = I18n.moment.tz.guess(),
  initTrackingForMeetings = true,
  trackingParams = {},
  abTestingParams = {},
  onSuccess,
  onFailure,
  locale,
  forceMobile,
  parentPageHSAnalyticsInfo = {},
  troubleshooting: troubleshootingActive = false,
  forcePropertyForm = null,
  allowTroubleshootMode = false,
  allowRedirect = false,
  disabledHsPopups,
  disablePrefill = false,
  isRescheduling = false,
  meetingChangeId = null,
  shouldSkipFirstAvailabilityPage = true
}) {
  const formStateFromParams = FormState.from(formState);
  const store = createStore({
    userSlug: slug,
    embedded,
    forceOffline,
    trackingParams: new TrackingParams(trackingParams),
    abTestingParams: new ABTestingParams(abTestingParams),
    initialFormState: formStateFromParams,
    stagedFormState: formStateFromParams,
    formState: null,
    currentTime: I18n.moment().valueOf(),
    userTimezone: timezone,
    initTrackingForMeetings,
    isRescheduling,
    meetingChangeId,
    onSuccess,
    onFailure,
    activeLocale: locale,
    forceMobile,
    parentPageHSAnalyticsInfo,
    troubleshooting: {
      active: troubleshootingActive
    },
    forcePropertyForm,
    allowTroubleshootMode,
    allowRedirect,
    disablePrefill
  }, httpClient);
  if (disabledHsPopups) {
    if (!window.disabledHsPopups) {
      window.disabledHsPopups = [];
    }
    window.disabledHsPopups.push(...disabledHsPopups);
  }
  const client = new DataFetchingClient();
  return props => {
    return /*#__PURE__*/_jsx(Provider, {
      store: store,
      children: /*#__PURE__*/_jsx(DataFetchingClientProvider, {
        client: client,
        children: /*#__PURE__*/_jsx(PublicAvailabilityInfoProvider, {
          slug: slug,
          shouldSkipFirstPage: shouldSkipFirstAvailabilityPage,
          meetingChangeId: meetingChangeId,
          children: /*#__PURE__*/_jsx(TroubleshootTimesContextProvider, {
            slug: slug,
            shouldSkipFirstPage: shouldSkipFirstAvailabilityPage,
            children: /*#__PURE__*/_jsx(ErrorBoundary, {
              children: /*#__PURE__*/_jsx(AppContainer, Object.assign({}, props))
            })
          })
        })
      })
    });
  };
}